export const SET_APPS_LIST = "SETTING THE APPS LIST";
export const SET_CURRENT_APP_NAME = "SETTING THE CURRENT APP NAME";
export const SET_IS_AUTHED = "SETTING AUTHENTICATION STATE";
export const SET_IS_SIGNING_IN = "SETTING SIGNING IN STATE";
export const SET_DEFAULT_APP_NAME = "SETTING THE DEFAULT APP NAME";
export const SET_FAVORITEAPPS_LIST = "SETTING THE FAVORITE APPS LIST";
export const SET_UPLOAD_ACTIVE = "SET_UPLOAD_ACTIVE";
export const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS";
